import { formatDiagnosticParameter } from '../../utils/formatDiagnosticParameter';
// src/components/CalibrationHistoryModal.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { ArrowLeft, ChevronLeft, ChevronRight } from 'lucide-react';
import { buildCalibrationGroups, getA200uCalibrationParameters, getCalibrationValue } from './calibrationDiagnostics';
import './calibrationhistorymodal.css';

const CalibrationHistoryModal = ({ isOpen, onClose, client }) => {
  const [calibrationData, setCalibrationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paramsLoading, setParamsLoading] = useState(false);
  const [selectedParams, setSelectedParams] = useState(null);
  const [showParamsModal, setShowParamsModal] = useState(false);
  const [detailIndex, setDetailIndex] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paramsCurrentPage, setParamsCurrentPage] = useState(1);
  const [paramsRowsPerPage, setParamsRowsPerPage] = useState(10);

  const API_BASE_URL = 'https://alcobrakeadmin.com/v3';

  // Helper function to extract value - matches Vue's way of handling
  const getValue = (obj) => {
    if (obj === undefined || obj === null || obj === '') return 'N/A';
    // Handle {String: "value", Valid: true} format
    if (typeof obj === 'object' && obj.String !== undefined) {
      return obj.String || 'N/A';
    }
    if (typeof obj === 'object') return JSON.stringify(obj, null, 2);
    return String(obj);
  };

  useEffect(() => {
    setDetailIndex(null);
    setShowParamsModal(false);
    setSelectedParams(null);
    if (isOpen && client) {
      setCurrentPage(1);
      setParamsCurrentPage(1);
      fetchCalibrationHistory();
    }
  }, [isOpen, client]);

  // Preserve every parameter snapshot, including legacy flat responses.
  const getUniqueObjects = (array) => {
    const groups = new Map();
    array.forEach(item => {
      const records = Array.isArray(item.records) ? item.records : [item];
      records.forEach(record => {
        const caldate = record.caldate ?? item.caldate;
        const key = JSON.stringify([caldate, record.devid ?? item.devid, record.cbid ?? item.cbid]);
        if (!groups.has(key)) groups.set(key, { caldate, records: [] });
        groups.get(key).records.push(record);
      });
    });
    return [...groups.values()];
  };

  const calibrationTimestamp = (value) => {
    const raw = value && typeof value === 'object' ? value.String : value;
    const date = moment.utc(raw || '', [
      moment.ISO_8601, 'MM/DD/YYYY HH:mm:ss', 'MM/DD/YYYY',
      'YYYY-MM-DD HH:mm:ss',
    ], true);
    return date.isValid() ? date.valueOf() : -Infinity;
  };

  const fetchCalibrationHistory = async () => {
    if (!client?.cbid && !client?.devId) return;
    
    setLoading(true);
    try {
      // Try with cbid first (newer devices)
      const hasCbid = Boolean(client.cbid);
      let url = hasCbid
        ? `${API_BASE_URL}/v2/caltrack/getdevcaltracks2?cbid=${client.cbid}`
        : `${API_BASE_URL}/v2/caltrack/getdevcaltracks?devId=${client.devId}`;
      let response = await axios.get(url, { timeout: 8000 });
      
      // If no data and we have devId, try with devId (older devices)
      if (hasCbid && (!response.data || response.data.length === 0) && client.devId) {
        url = `${API_BASE_URL}/v2/caltrack/getdevcaltracks?devId=${client.devId}`;
        response = await axios.get(url, { timeout: 8000 });
      }
      
      if (response.data && response.data.length > 0) {
        // Sort complete groups by the date displayed in the history table.
        const uniqueRecords = getUniqueObjects(response.data).sort((a, b) => {
          const dateA = calibrationTimestamp(a.caldate);
          const dateB = calibrationTimestamp(b.caldate);
          return dateA === dateB ? 0 : dateA < dateB ? 1 : -1;
        });
        
        setCalibrationData(uniqueRecords);
      } else {
        setCalibrationData([]);
      }
    } catch (error) {
      console.error('Failed to fetch calibration history:', error);
      setCalibrationData([]);
    } finally {
      setLoading(false);
    }
  };

  // const handleShowParameters = async (item, e) => {
  //   console.log(item,"ttttttttttttttttt")
  //   e.stopPropagation();
  //   setSelectedParams([]);
  //   setParamsCurrentPage(1);
  //   setShowParamsModal(true);
  //   setParamsLoading(true);
  //   try {
  //     // Fetch fresh data for parameters - MATCH VUE
  //     const hasCbid = Boolean(client.cbid);
  //     let url = hasCbid
  //       ? `${API_BASE_URL}/v2/caltrack/getdevcaltracks2?cbid=${client.cbid}`
  //       : `${API_BASE_URL}/v2/caltrack/getdevcaltracks?devId=${client.devId}`;
  //     let response = await axios.get(url, { timeout: 8000 });
      
  //     if (hasCbid && (!response.data || response.data.length === 0) && client.devId) {
  //       url = `${API_BASE_URL}/v2/caltrack/getdevcaltracks?devId=${client.devId}`;
  //       response = await axios.get(url, { timeout: 8000 });
  //     }
      
  //     if (response.data && response.data.length > 0) {
  //       // Filter records with same caldate - MATCH VUE
  //       console.log(response.data,"//////////////////qqqq")
  //       const paramsRecords = response.data.filter(
  //         record => record.caldate === item.caldate && record.devid === item.devid
  //       );
        
  //       // Sort by updatedtime
  //       const sortedParams = [...paramsRecords].sort((a, b) => {
  //         const dateA = new Date(a.updatedtime);
  //         const dateB = new Date(b.updatedtime);
  //         return dateB - dateA;
  //       });
  //       // console.log(sortedParams,"//////////////////")
  //       setSelectedParams(sortedParams);
  //     } else {
  //       setSelectedParams([]);
  //     }
  //   } catch (error) {
  //     console.error('Failed to fetch parameters:', error);
  //     setSelectedParams([]);
  //   } finally {
  //     setParamsLoading(false);
  //   }
  // };

  const handleShowParameters = async (item, e) => {
  e.stopPropagation();

  setSelectedParams([]);
  setDetailIndex(null);
  setParamsCurrentPage(1);
  setShowParamsModal(true);
  setParamsLoading(true);

  try {
    // Item is already grouped and contains the parameter records
    const records = Array.isArray(item?.records) ? item.records : [];

    if (records.length > 0) {
      // Sort records by updatedtime - newest first
      const sortedParams = [...records].sort((a, b) => {
        const dateA = new Date(a?.updatedtime || 0);
        const dateB = new Date(b?.updatedtime || 0);

        return dateB - dateA;
      });

      setSelectedParams(sortedParams);
    } else {
      setSelectedParams([]);
    }
  } catch (error) {
    console.error('Failed to load parameters:', error);
    setSelectedParams([]);
  } finally {
    setParamsLoading(false);
  }
};

  const closeParamsModal = (e) => {
    if (e) e.stopPropagation();
    setShowParamsModal(false);
    setSelectedParams(null);
    setDetailIndex(null);
  };

  // Pagination calculations for main table
  const indexOfLastRecord = currentPage * rowsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - rowsPerPage;
  const currentRecords = calibrationData.slice(indexOfFirstRecord, indexOfLastRecord);

  // console.log(currentRecords,"[[[[[[[[[[[[[[[[[[[")
  const totalPages = Math.ceil(calibrationData.length / rowsPerPage);

  // Pagination calculations for parameters table
  const paramsIndexOfLastRecord = paramsCurrentPage * paramsRowsPerPage;
  const paramsIndexOfFirstRecord = paramsIndexOfLastRecord - paramsRowsPerPage;
  const currentParamsRecords = selectedParams ? selectedParams.slice(paramsIndexOfFirstRecord, paramsIndexOfLastRecord) : [];
  const paramsTotalPages = selectedParams ? Math.ceil(selectedParams.length / paramsRowsPerPage) : 0;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleParamsPageChange = (page) => {
    if (page >= 1 && page <= paramsTotalPages) {
      setParamsCurrentPage(page);
    }
  };

  const detailRecord = detailIndex === null ? null : selectedParams?.[detailIndex];
  const isA200u = String(client?.devicemode || client?.deviceMode || client?.devicemodel || '').trim().toUpperCase() === 'A200U';
  const detailGroups = detailRecord ? buildCalibrationGroups(detailRecord, isA200u) : [];
  const fieldCount = detailGroups.reduce((total, group) => total + group.items.length, 0);

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="calibration-modal" onClick={(e) => e.stopPropagation()}>
          <div className="calibration-modal-header">
            <h3>Calibration History</h3>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>
          
          <div className="calibration-modal-body">
            {loading ? (
              <div className="calibration-loading">
                <div className="loader"></div>
                <span>Loading calibration history...</span>
              </div>
            ) : calibrationData.length === 0 ? (
              <div className="calibration-empty">
                <p>No calibration history found</p>
              </div>
            ) : (
              <>
                <div className="calibration-table-container">
                  <table className="calibration-table">
                    <thead>
                      <tr>
                        <th>Device ID</th>
                        <th>Handset</th>
                        <th>Calibration Date</th>
                        <th>More</th>
                    </tr>
                    </thead>
                    <tbody>
                      {currentRecords.map((item, index) => (
                        <tr key={index}>
                          <td>{getValue(item.records[0].cbid) || 'N/A'}</td>
                          <td>{getValue(item.records[0].devid) || 'N/A'}</td>
                          <td>{getValue(item.caldate) || 'N/A'}</td>
                          <td>
                            <button 
                              className="view-params-icon"
                              onClick={(e) => handleShowParameters(item, e)}
                              title="Show Parameters"
                            >
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="3"/>
                                <path d="M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10z"/>
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                {/* Pagination for main table */}
                {totalPages > 1 && (
                  <div className="pagination-controls">
                    <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>«</button>
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>‹</button>
                    <span>Page {currentPage} of {totalPages}</span>
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>›</button>
                    <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>»</button>
                    <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                      <option value={5}>5 per page</option>
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                    </select>
                  </div>
                )}
              </>
            )}
          </div>
          
          {/* <div className="calibration-modal-footer">
            <button className="btn-secondary" onClick={onClose}>Close</button>
          </div> */}
        </div>
      </div>

      {/* Parameters Modal - MATCHES VUE EXACTLY */}
      {showParamsModal && (
        <div className="modal-overlay" onClick={closeParamsModal}>
          <div className={`params-modal ${detailRecord ? 'calibration-history-details' : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="params-modal-header">
              <h3>{detailRecord ? 'Calibration Record Details' : 'Device Parameters'}</h3>
              <button className="close-btn" onClick={closeParamsModal}>✕</button>
            </div>
            <div className="params-modal-body">
              {detailRecord ? (
                <>
                  <div className="calibration-record-toolbar">
                    <button className="calibration-record-back" onClick={() => { setParamsCurrentPage(Math.floor(detailIndex / paramsRowsPerPage) + 1); setDetailIndex(null); }}><ArrowLeft size={16} />Back to parameters</button>
                    <div className="calibration-record-navigation">
                      <button aria-label="Previous record" disabled={detailIndex === 0} onClick={() => setDetailIndex(index => index - 1)}><ChevronLeft size={16} /><span>Previous</span></button>
                      <div className="calibration-record-count" aria-live="polite"><strong>Record {detailIndex + 1} of {selectedParams.length}</strong><small>{fieldCount} parameters</small></div>
                      <button aria-label="Next record" disabled={detailIndex === selectedParams.length - 1} onClick={() => setDetailIndex(index => index + 1)}><span>Next</span><ChevronRight size={16} /></button>
                    </div>
                  </div>
                  <div className="diagnostics-sections">
                    {detailGroups.map(group => {
                      const GroupIcon = group.icon;
                      return <section className="diagnostics-section" key={group.title}>
                        <div className="diagnostics-section-header"><GroupIcon size={17} /><span>{group.title}</span></div>
                        <div className="diagnostics-card-grid">
                          {group.items.map(item => {
                            const ItemIcon = item.icon;
                            return <div className={`diagnostics-data-card ${item.inline ? 'inline-value' : ''}`} key={item.label}>
                              <span className="diagnostics-card-icon"><ItemIcon size={21} /></span>
                              <span className="diagnostics-card-content"><span className="diagnostics-card-label">{item.label}</span><strong>
  {item.value}
</strong></span>
                            </div>;
                          })}
                        </div>
                      </section>;
                    })}
                  </div>
                </>
              ) : paramsLoading ? (
                <div className="calibration-loading"><div className="loader"></div><span>Loading device parameters...</span></div>
              ) : currentParamsRecords.length === 0 ? (
                <div className="calibration-empty"><p>No device parameters found</p></div>
              ) : <div className="params-table-container">
                <table className="params-table">
                  <thead>
                    <tr>
                      <th>Device ID</th>
                      <th>Handset</th>
                      <th>Updated Time</th>
                      <th>Calibration Date</th>
                      <th>ASO</th>
                      <th>Brac Peak Factor</th>
                      <th>Offset Pressure</th>
                      <th>F/W Version</th>
                      <th>C/B Version</th>
                      <th>Co2 Enable / Disable</th>
                      <th>Engine Run ADC</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentParamsRecords.map((param, idx) => (
                      <tr key={idx}>
                        <td>{getValue(param.cbid) || 'N/A'}</td>
                        <td>{getValue(param.devid) || 'N/A'}</td>
                        <td>{(getValue(param.updatedtime) || 'N/A').replace('(IST)','')}</td>
                        <td>{getValue(param.caldate) || 'N/A'}</td>
                        <td>{getValue(param.alcooffset) || getValue(param.aso) || 'N/A'}</td>
                        <td>{getValue(param.bracpeakfactor) || 'N/A'}</td>
                        <td>{getValue(param.offset_pressure) || getValue(param.offsetpressure) || 'N/A'}</td>
                        <td>{getValue(param.fwversion) || 'N/A'}</td>
                        <td>{getValue(param.cbversion) || 'N/A'}</td>
                        {/* <td>{getCalibrationValue(isA200u ? getA200uCalibrationParameters(param) : param, ['proxy_en_dis'])}</td> */}
                        <td>
  {formatDiagnosticParameter(
    'proxy_en_dis',
    getCalibrationValue(
      isA200u ? getA200uCalibrationParameters(param) : param,
      ['proxy_en_dis']
    )
  )}
</td>
                        <td>{getValue(param.erunadc ?? param.engineRunAdc)}</td>
                        <td><button className="btn-secondary" onClick={() => setDetailIndex(paramsIndexOfFirstRecord + idx)}>View Details</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>}
              
              {/* Pagination for parameters table */}
              {!detailRecord && !paramsLoading && paramsTotalPages > 1 && (
                <div className="pagination-controls">
                  <button onClick={() => handleParamsPageChange(1)} disabled={paramsCurrentPage === 1}>«</button>
                  <button onClick={() => handleParamsPageChange(paramsCurrentPage - 1)} disabled={paramsCurrentPage === 1}>‹</button>
                  <span>Page {paramsCurrentPage} of {paramsTotalPages}</span>
                  <button onClick={() => handleParamsPageChange(paramsCurrentPage + 1)} disabled={paramsCurrentPage === paramsTotalPages}>›</button>
                  <button onClick={() => handleParamsPageChange(paramsTotalPages)} disabled={paramsCurrentPage === paramsTotalPages}>»</button>
                  <select value={paramsRowsPerPage} onChange={(e) => { setParamsRowsPerPage(Number(e.target.value)); setParamsCurrentPage(1); }}>
                    <option value={5}>5 per page</option>
                    <option value={10}>10 per page</option>
                    <option value={25}>25 per page</option>
                    <option value={50}>50 per page</option>
                  </select>
                </div>
              )}
            </div>
            <div className="params-modal-footer">
              <button className="btn-secondary" onClick={closeParamsModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalibrationHistoryModal;
